var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookLogin = function SvgFacebookLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 23 23",
    width: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#ffd7d7",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.5985854 12.2992927c0-6.23995535-5.0593374-11.2992927-11.2992927-11.2992927-6.23995535 0-11.2992927 5.05933735-11.2992927 11.2992927 0 5.6393179 4.13136844 10.3141202 9.5339272 11.1626397v-7.8956807h-2.86971211v-3.266959h2.86971211v-2.48994399c0-2.83157637 1.6875051-4.39672942 4.2680214-4.39672942 1.2362325 0 2.5296686.22086932 2.5296686.22086932v2.78072876h-1.4253221c-1.4030762 0-1.8416369.87076534-1.8416369 1.76536553v2.1197098h3.1334841l-.5005312 3.266959h-2.6329529v7.8956807c5.4025587-.8469305 9.5339272-5.5217328 9.5339272-11.1626397z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6976111 15.3895988.5005312-3.2669591h-3.1334841v-2.1197098c0-.89301115.4369717-1.76536549 1.8416369-1.76536549h1.4253221v-2.78072876s-1.2934361-.22086931-2.5296686-.22086931c-2.5805163 0-4.2680214 1.56356405-4.2680214 4.39672941v2.48994395h-2.86971211v3.2669591h2.86971211v7.8956807c.5752136.0905723 1.1647281.1366529 1.7653655.1366529s1.1901519-.0476696 1.7653655-.1366529v-7.8956807z",
    fill: "#1878f2"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookLogin, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/FacebookLogin.ba2b6cd8.svg";
export { ForwardRef as ReactComponent };